<template>
  <div class="page">
    <nav-bar
      v-if="!hideBar"
      v-bind="$route.meta"
      :fixed-config="navStyles"
      :title="title"
      :styles="navStylesObj"
      :class="{ 'no-top': noTop }"
    >
      <div slot="leftSlot" />
      <!-- <div slot="rightSlot" class="open-app">
        打开APP<van-icon name="arrow" />
        <hn-app-launch
          class="down-button-ap"
          :bt-title="'打开APP'"
          launch-text=""
        />
      </div> -->
    </nav-bar>
    <div class="box">
      <img src="https://files.cnhnb.com/shangpin/ok.png" class="status-bg">
      <div class="status-h1">发布完成</div>
      <div class="tips">
        您已经发布“{{
          cateName
        }}”供货信息，您可以下载惠农网APP关注采购情况，不错过任何商机哦！
      </div>
      <div class="level">市场竞争力评级</div>
      <div class="level-box">
        <div class="leve-text">弱</div>
        <div class="level-process" />
      </div>
      <div class="way">
        <div>您当前发布的商品市场竞争力低于70%的卖家，提升方式：</div>
        <div class="hi-lignt">1、给商品发布视频介绍</div>
        <div class="hi-lignt">2、介绍一下您的供货能力</div>
      </div>
      <div class="down-btn" @click="goDownload">
        下载APP去提升评级
        <!-- <hn-app-launch
          class="down-button-ap"
          :bt-title="'打开APP'"
          launch-text=""
        /> -->
      </div>
      <div class="prev" @click="$router.go(-1)">返回上级</div>
    </div>
  </div>
</template>

<script>
const uiDatas = {
  show: false,
  title: '发布成功',
  navStyles: {
    originBgColor: 'rgba(255, 255,255)'
  },
  navStylesObj: {
    color: 'black'
  },
  noTop: false,
  hideBar: false
}
export default {
  name: 'Result',
  data() {
    return {
      ...uiDatas,
      cateName: ''
    }
  },
  created() {
    const { name } = this.$route.query || {}
    console.info('this.$router.query', this.$route.query)
    this.cateName = name
  },
  methods: {
    goDownload() {
      console.log(this.$env)
      const { isAndroid, inWxBrowser } = this.$env
      if (inWxBrowser) return (location.href = 'http://zhuanti.cnhnb.com/zhuanti/download')
      location.href = isAndroid ? 'https://i.cnhnb.com/5djE' : 'https://apps.apple.com/cn/app/1024434395'
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-top: calc(var(--hn-top-safearea) + 88px);
  box-sizing: border-box;
}
.down-button-ap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  display: block !important;
  /deep/ .down-button-ap {
    display: block !important;
    height: 100%;
  }
}
.open-app {
  background-image: linear-gradient(270deg, #f0fff0 0%, #e1fbe3 100%);
  border-radius: 35px 0px 0px 35px;
  width: 176px;
  height: 60px;
  font-family: PingFangSC-Semibold;
  font-size: 30px;
  box-sizing: border-box;
  padding-left: 20px;
  color: #39bf3e;
  letter-spacing: 0;
  text-align: right;
  font-weight: 600;
  margin-right: -14px;
  line-height: 60px;
  text-align: center;
  position: relative;
}
.status-bg {
  width: 80px;
  height: 80px;
  display: flex;
  margin-bottom: 16px;
}
.box {
  padding-top: 118px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.status-h1 {
  font-family: PingFangSC-Medium;
  font-size: 36px;
  color: #1a1a1a;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  height: 50px;
  line-height: 50px;
  margin-bottom: 32px;
}
.tips {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  width: 654px;
  text-align: left;
  margin-bottom: 88px;
}
.level {
  font-family: PingFangSC-Medium;
  font-size: 40px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  height: 56px;
  line-height: 56px;
  box-sizing: border-box;
  padding: 0 10px;
}
.level-box {
  width: 638px;
  margin: 0 auto;
  text-align: left;
  margin-bottom: 16px;
}
.level-text {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 36px;
  font-weight: 400;
  height: 36px;
  text-align: left;
  margin-bottom: 4px;
}
.level-process {
  background: #f5f5f5;
  width: 638px;
  height: 28px;
  position: relative;
  &::before {
    content: " ";
    height: 100%;
    width: 172px;
    background: #cccccc;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.way {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #333333;
  letter-spacing: 0;
  line-height: 40px;
  font-weight: 400;
  width: 620px;
  text-align: left;
  align-self: flex-start;
  margin-left: 56px;
  margin-bottom: 100px;
}
.hi-lignt {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ff862c;
  letter-spacing: 0;
  line-height: 40px;
  font-weight: 400;
}
.down-btn {
  position: relative;
  width: 686px;
  height: 88px;
  background: #39bf3e;
  border-radius: 44px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
}
.prev {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #999999;
  text-align: center;
  line-height: 45px;
  font-weight: 400;
}
</style>
